import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
const DEFAULT_AMIMATION_SPEED = 5;
export const CircleProgress = ({ onClick, progressValue, progressMax, color, trackColor, circleBorder, circleDiameter, roundedEdges, isAnimated, amimationSpeed, children, }) => {
    const [progressPercentage, setProgressPercentage] = React.useState(0);
    const [showRoundedEdges, setShowRoundedEdges] = React.useState(false);
    React.useEffect(() => {
        if (!isAnimated) {
            const value = (progressValue / progressMax) * 100;
            setProgressPercentage(value);
            setShowRoundedEdges(roundedEdges && value > 0 && value < 100);
            return;
        }
        let step = 0;
        const target = (progressValue / progressMax) * 100;
        const increment = target / 100;
        const updateProgress = () => {
            step += increment;
            if (step <= target) {
                setProgressPercentage(step);
                setShowRoundedEdges(roundedEdges && step > 0 && step < 100);
            }
            else {
                clearInterval(intervalId);
            }
        };
        const intervalId = setInterval(updateProgress, amimationSpeed ? amimationSpeed : DEFAULT_AMIMATION_SPEED);
        return () => clearInterval(intervalId);
    }, [progressValue, progressMax]);
    const progressStyles = createProgressStyles(progressPercentage, color, trackColor, circleBorder, circleDiameter, showRoundedEdges);
    return (React.createElement("div", { className: css(progressStyles.circle), onClick: onClick },
        showRoundedEdges && React.createElement("div", { className: css(progressStyles.startEdge) }),
        showRoundedEdges && React.createElement("div", { className: css(progressStyles.endEdge) }),
        children ? children : React.createElement("span", { className: css(progressStyles.text) }, progressValue)));
};
const createProgressStyles = (progressPercentage, color, trackColorProps, circleBorderProps, circleDiameterProps, roundedEdges) => {
    const trackColor = trackColorProps ? trackColorProps : '#EFEFEF';
    const circleBorder = circleBorderProps ? circleBorderProps : 12;
    const circleDiameter = circleDiameterProps ? circleDiameterProps : 75;
    // 円グラフのエッジに丸みを効かせていることにより
    // 進捗が実際よりも進んでしまっているように見えるので開始位置をずらす
    let startPercentage = roundedEdges ? 1 : 0;
    // 終了位置も必要であればずらす
    const nearlyFinidhedPercentage = 98;
    // 進捗率が0より大きくstartPercentage未満であれば、startPercentageの値に合わせる
    if (0 < progressPercentage && progressPercentage < startPercentage) {
        progressPercentage = startPercentage;
        // 進捗率がnearlyFinidhedPercentage以上100%未満であれば、nearlyFinidhedPercentageの値に合わせる
    }
    else if (nearlyFinidhedPercentage < progressPercentage && progressPercentage < 100) {
        progressPercentage = nearlyFinidhedPercentage;
        // 進捗率が100%であれば、グラフを埋めるためにstartPercentageの値を0に変更する
    }
    else if (progressPercentage == 100) {
        startPercentage = 0;
    }
    return StyleSheet.create({
        circle: {
            width: circleDiameter,
            height: circleDiameter,
            aspectRatio: 1,
            position: 'relative',
            display: 'inline-grid',
            placeContent: 'center',
            justifyItems: 'center',
            fontWeight: 'bold',
            fontFamily: 'Noto Sans JP',
            '::before': {
                content: "''",
                position: 'absolute',
                borderRadius: '50%',
                inset: 0,
                background: `conic-gradient(${trackColor} 0% ${startPercentage}%, ${color} ${startPercentage}% calc(${progressPercentage}%), ${trackColor} 0)`,
                mask: `radial-gradient(farthest-side,#0000 calc(99% - ${circleBorder}px), #000 calc(100% - ${circleBorder}px))`,
                '-webkit-mask': `radial-gradient(farthest-side,#0000 calc(99% - ${circleBorder}px), #000 calc(100% - ${circleBorder}px))`,
            },
        },
        startEdge: {
            position: 'absolute',
            borderRadius: '50%',
            inset: `calc(50% - ${circleBorder}px/2)`,
            background: color,
            transform: `rotate(calc(${startPercentage}*3.6deg)) translateY(calc(50% - ${circleDiameter}px/2))`,
        },
        endEdge: {
            position: 'absolute',
            borderRadius: '50%',
            inset: `calc(50% - ${circleBorder}px/2)`,
            background: color,
            transform: `rotate(calc(${progressPercentage}*3.6deg)) translateY(calc(50% - ${circleDiameter}px/2))`,
        },
        text: {
            color: color,
            size: '16px',
            fontWeight: 'bold',
        },
    });
};
